import React, {useEffect, useState} from 'react';
import LandingPageService from 'services/backend/landingPage';
//import { versionNumber }  from 'constants/VersionNumber';


const Footer = () => {
  let date = new Date();
  let year = date.getFullYear();
  const [versionNumber, setVersionNumber] = useState("2.0.0");
  const [urgencia, setUrgencia] = useState("");
  const landingService = new LandingPageService()
  useEffect(() => {
    getLandingPageData();
  }, []);

  const getLandingPageData = () => {
    console.log("Estoy llamando a la función");
    landingService.GetLandingPageData().then(response => {
      if (response.data && response.data.length > 0) {
        response.data.forEach(item => {
          console.log("El parametro que veré ahora es")
          console.log(item.parametro)
          if (item.parametro === "num_version") {
            setVersionNumber(item.valor);
          } else if (item.parametro === "urgencia"){
            if(item.activo){
              setUrgencia(item.valor);
            }
          }

        });
      } else {
        // Manejar el caso de datos vacíos
        console.log("No hay datos disponibles");
        setVersionNumber("Versión no disponible");
      }
    }).catch(error => {
      console.error("Error al obtener los datos:", error);
      // Manejar errores de solicitud aquí
    });
  };
  return (
    <footer className="app-footer" style={{ width: "100%" }}>
      {/* Contenedor principal para el texto y el enlace */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
        <span>
          Ministerio de Transportes y Telecomunicaciones - Gobierno de Chile &copy; {year} {versionNumber}
        </span>
        <a href="https://soporteseim.freshdesk.com/" target="_blank" rel="noopener noreferrer">
          Contacto con soporte
        </a>
      </div>
      
      {/* Espaciado para asegurar separación entre las secciones */}
      <br />
      
      {/* Texto de urgencia */}
      {urgencia && (
        <span
          style={{
            color: "red",
            fontWeight: "bold",
            display: "block",
            textAlign: "center", // Centra la urgencia horizontalmente.
            marginTop: "10px", // Añade separación con el resto.
          }}
        >
          {urgencia}
        </span>
      )}
    </footer>


  );
}
  ;

export default Footer;
